<template>
    <div class="fir container">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <p class="heading has-text-weight-bold is-size-5">FIRs</p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button style="background-color: #eff1fa;
                                        color: #3850b7;" class="is-small is-light  button" @click="notamWordsModal = true">
                                    <!--                                  <span class="icon is-small">-->
                                    <!--                                      <i class="fas fa-plus-circle"></i>-->
                                    <!--                                  </span>-->
                                    <span>Manage Important Notam Words</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button :disabled="!addRecord" class="is-small is-light  button"
                                        @click="TryAddRecord()">
                                  <span class="icon is-small">
                                      <i class="fas fa-save"></i>
                                  </span>
                                    <span>Save</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button :disabled="!isEditing" class="is-small is-light  button"
                                        @click="TryUpdateRecord()">
                                  <span class="icon is-small">
                                      <i class="fas fa-save"></i>
                                  </span>
                                    <span>Update</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button class="is-small is-light  button" @click="addRecord=true">
                                  <span class="icon is-small">
                                      <i class="fas fa-plus-circle"></i>
                                  </span>
                                    <span>Add</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button :disabled="selectedFIR==null" class="is-small is-light  button"
                                        @click="isEditing=true">
                                  <span class="icon is-small">
                                      <i class="fas fa-plus-circle"></i>
                                  </span>
                                    <span>Edit</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button :disabled="!isDisabledCancel" class="button is-small is-light "
                                        @click="addRecord=false,isEditing=false">
                                  <span class="icon is-small">
                                    <i class="fas fa-trash-alt"></i>
                                  </span>
                                    <span>Cancel</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button :disabled="selectedFIR == null" class="button is-small is-light "
                                        @click="TryDeleteRecord()">
                                  <span class="icon is-small">
                                    <i class="fas fa-trash-alt"></i>
                                  </span>
                                    <span>Delete</span>
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns" style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip">
                        <font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">It is the mapping management screen of the airports of FOR used by the
                                        integration.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can create a new FIR</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can delete FIR</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can update FIR</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">The integration obtains notam information using FIR information.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="!isLoading" class="fir-table">
            <table
                    class="table is-narrow is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp animate__faster">
                <thead>
                <tr>
                    <th width="150px">FIR</th>
                    <th width="150px">FIR Name</th>
                    <th width="150px">Country</th>
                    <th width="200px">Airports</th>
                    <!--                    <th width="150px">Act</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-if="addRecord">
                    <td><input type="text" class="input is-small" v-model="addModal.FIR"></td>
                    <td><input type="text" class="input is-small" v-model="addModal.FIR_NAME"></td>
                    <td>
                        <input type="text" class="input is-small" v-model="addModal.COUNTRY">
                        <!-- <div class="select is-small">
                            <select class="is-small" v-model="addModal.COUNTRY">
                                <option v-for="country in countryList" :key="country">{{country}}</option>
                            </select>
                        </div> -->
                    </td>
                    <td><input type="text" class="input is-small" v-model="addModal.AIRPORTS"></td>
                    <!--                    <td>-->
                    <!--                                                <span><button class="button is-light is-success is-small" @click="TryAddRecord()">Save</button></span>-->
                    <!--                                                <span><button class="button is-light is-danger is-small" @click="addRecord=false">Cancel</button></span>-->
                    <!--                    </td>-->
                </tr>
                <tr v-for="fir in FIRsList" :key="fir.fir" v-bind:class="{'is-selected': selectedFIR === fir}"
                    @click="firFilter(fir)">
                    <td>
                        <p v-if="!iseditRow(fir)">{{ fir.fir }}</p>
                        <input v-else type="text" class="input is-small" v-model="fir.fir" disabled
                               @input=" selectedFIRForm.FIR=$event.target.value">
                    </td>

                    <td>
                        <p v-if="!iseditRow(fir)">{{ fir.fiR_NAME }}</p>
                        <input v-else type="text" class="input is-small" v-model="fir.fiR_NAME"
                               @input=" selectedFIRForm.FIR_NAME=$event.target.value">
                    </td>

                    <td>
                        <p v-if="!iseditRow(fir)">{{ fir.country }}</p>
                        <input v-else type="text" class="input is-small" v-model="fir.country"
                               @input=" selectedFIRForm.COUNTRY=$event.target.value">
                        <!-- <div v-else class="select is-small">
                            <select class="is-small" @change="selectedFIRForm.COUNTRY=$event.target.value"
                                    v-model="fir.country">
                                <option v-for="country in countryList" :key="country">{{country}}</option>
                            </select>
                        </div> -->

                    </td>

                    <td>
                        <p v-if="!iseditRow(fir)">{{ fir.airports }}</p>
                        <input v-else type="text" class="input is-small" v-model="fir.airports"
                               @input=" selectedFIRForm.AIRPORTS=$event.target.value">
                    </td>
                </tr>

                </tbody>
            </table>
        </div>
        <div v-else>
            <loading-button/>
        </div>

        <div class="modal " :class="{'is-active':notamWordsModal}">
            <div class="modal-background" @click="notamWordsModal = false"></div>
            <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:45%; height: 70%;">
                <header class="modal-card-head">
                    <p class="modal-card-title">Manage Important Notam Words</p>
                    <button class="delete is-large" aria-label="close" @click="notamWordsModal=false">Close</button>
                </header>

                <section class="modal-card-body" style="width: 100%; height: 100%">

                    <!-- Region Name -->
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Word</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <!--                                            <input v-if="WeatherRegion.id != null" class="input " type="text" v-model="WeatherRegion.RegionName">-->
                                    <input class="input" type="text" v-model="notamWordsForm.Word">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Word
                    Color
                    Style
                    IsDeleted
                    WhoChanged-->
                    <!-- FIR -->
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Color</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <!--                                            <input v-if="WeatherRegion.id != null" class="input " type="text" v-model="WeatherRegion.FIR">-->
                                    <!--                    <input class="input " type="select" >-->
                                    <div style="width: 100%">
<!--                                        <select style="width: 100%">-->
<!--                                            <option v-for="(color,index) in colorList" :key="index" :value="color.value">{{-->
<!--                                                color.color-->
<!--                                                }}-->
<!--                                            </option>-->
<!--                                        </select>-->
                                        <v-select :options="colorList" v-model="notamWordsForm.Color"></v-select>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Style</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <!--                                            <input v-if="WeatherRegion.id != null" class="input " type="text" v-model="WeatherRegion.FIR">-->
                                    <!--                    <input class="input " type="select" >-->
                                    <div style="width: 100%">
                                        <v-select :options="styleList" v-model="notamWordsForm.Style"></v-select>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Save Button -->
                    <div class="field">
                        <div class="control">
                            <div class="control">
                                <button class="create-button button" @click="AddNotamWords(notamWordsForm)">
                                          <span class="icon is-small">
                                             <i class="fas fa-save"></i>
                                          </span>
                                    <span>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <table class="table is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp ">
                        <thead>
                        <tr>
                            <th style="width: 20px">Id</th>
                            <th style="width: 30px">Word</th>
                            <th style="width: 80px">Color</th>
                            <th style="width: 60px">Style</th>
                            <th style="width: 100px">ACT</th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="notam in NotamImportantListModule" :key="notam.id">
                            <td>{{ notam.id }}</td>
                            <td>
                                <p v-if="!notam.isEditing">{{ notam.word }}</p>
                                <input v-else class="input" type="text" v-model="notamWordsForm.Word">
                            </td>

                            <td>
                                <p v-if="!notam.isEditing">{{ notam.color }}</p>
                                <!--                  <input class="input" type="text" >-->
                                <div v-else style="width: 100%">
                                    <v-select :options="colorList" v-model="notamWordsForm.Color"></v-select>
                                </div>
                            </td>

                            <td>
                                <p v-if="!notam.isEditing">{{ notam.style }}</p>
                                <div v-else style="width: 100%">
                                    <v-select :options="styleList" v-model="notamWordsForm.Style"></v-select>
                                </div>
                            </td>

                            <td>
                                <div class="read" v-if="!notam.isEditing">
                                    <button class="button is-small is-light is-info" style="margin-left: 5px;"
                                            @click="GetTrueNotamButtonIsEditing(notam)">
                                        <span class="icon is-small"><font-awesome-icon icon="edit"/></span>
                                        <span>Edit</span>
                                    </button>
                                </div>
                                <div class="write" v-else>

                                    <button class="button is-small is-light is-success"
                                            style="margin-left: 5px;"
                                            @click="UpdateNotamWords(notam)"
                                    > <!-- ,region.isEditing=false-->

                                        <span class="icon is-small"><font-awesome-icon icon="check"/></span>
                                        <span>Save</span>
                                    </button>
<!--                                    @click="           DeleteNotamWords(notam-->
                                    <button class="button is-small is-light is-warning"
                                            style="margin-left: 5px;"
                                            @click="AssignDeletionItem(notam)"
                                    > <!-- ,region.isEditing=false-->
                                        <span class="icon is-small"><font-awesome-icon icon="box"/></span>
                                        <span>Delete</span>
                                    </button>

                                    <!--
                                    <button class="button is-small is-light is-warning" style="margin-left: 5px;" @click="deleteRegionButton=true,region.isCreating=true">
                                        <span class="icon is-small"><font-awesome-icon icon="box"/></span>
                                        <span>Delete</span>
                                    </button>
                                    -->

                                    <button class="button is-small is-light is-danger"
                                            style="margin-left: 5px;"
                                            @click="GetFalseNotamButtonIsEditing(notam)"
                                    >
                                        <span class="icon is-small"><font-awesome-icon icon="times"/></span>
                                        <span>Cancel</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </section>

                <footer class="modal-card-foot">


                </footer>
            </div>
        </div>
        <div class="modal" :class="{'is-active':deleteNotamWordsModal}">
            <div class="modal-background" @click="deleteNotamWordsModal = false"></div>
            <div class="modal-content">
                <section class="modal-card-body" style="width: 100%; height: 100%">

                    <!-- Region Name -->
                    <div class="field is-horizontal">

                        <div class="modal-dialog modal-confirm">
                            <div class="modal-content">
                                <div class="modal-header flex-column">
                                    <div class="icon-box">
                                        <font-awesome-icon style="height: 75px; width: 75px; color: #f15e5e;" icon="times"/>
                                    </div>
                                    <h4 class="modal-title w-100">Are you sure?</h4>
                                </div>
                                <div class="modal-body" style="margin:20px 0 20px 0">
                                    <p>Do you really want to delete these records? This process cannot be undone.</p>
                                </div>
                                <div class="modal-footer justify-content-center">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="NotamWordDeletionCancel()">Cancel</button>
                                    <!-- <button type="button" class="btn btn-danger" @click="isDelete = true">Delete</button> -->
                                    <button type="button" class="btn btn-danger" @click="NotamWordDeletionProcStart()">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import {loadingMixin} from "../../../utils/mixins";
    import LoadingButton from "../../../components/ui/LoadingButton";
    // import WeatherMatrixService from "@/services/weathermatrix.service";

    const {mapState, mapActions} = createNamespacedHelpers('firs');
    export default {
        name: "FIRs",
        mixins: [loadingMixin],
        components: {
            LoadingButton,
        },
        data() {
            return {
                // bunuda silelim :D
                data: [
                    {
                        "Id": 1,
                        "Word": "Closed",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 2,
                        "Word": "Closure",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 3,
                        "Word": "CLSD",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 4,
                        "Word": "Downgrade",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 5,
                        "Word": "Downgraded",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 6,
                        "Word": "Open",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 7,
                        "Word": "Withdrawn",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {"Id": 8, "Word": "ILS", "Color": "red", "Style": "bold", "IsDeleted": 0, "WhoChanged": "", "isEditing": false},
                    {"Id": 9, "Word": "RWY", "Color": "red", "Style": "bold", "IsDeleted": 0, "WhoChanged": "", "isEditing": false},
                    {
                        "Id": 10,
                        "Word": "Runway",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 11,
                        "Word": "Unserviceable",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 12,
                        "Word": "Covid",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 13,
                        "Word": "U/S",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 14,
                        "Word": "Exercise",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 15,
                        "Word": "Strike",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    },
                    {
                        "Id": 16,
                        "Word": "Contamination",
                        "Color": "red",
                        "Style": "bold",
                        "IsDeleted": 0,
                        "WhoChanged": "",
                        "isEditing": false
                    }
                ],
                deleteNotamWordsModal: false,
                isDelete: false,
                notamWordsForm:
                    {
                        Id: 0,
                        Word: "",
                        Color: "",
                        Style: "",
                        IsDeleted: 0,
                        WhoChanged: "",
                        isEditing: false
                    },

                notamWordFormWillDelete: null,

                colorList: ["red","blue","green","yellow"],
                styleList: ["bold","normal","lighter"],
                notamWordsModal: false,
                editNotamButton: false,
                addRecord: false,
                editFIR: null,
                isEditing: false,
                selectedFIR: null,
                selectedFIRForm: {
                    FIR: "",
                    FIR_NAME: "",
                    COUNTRY: "",
                    AIRPORTS: ""
                },
                addModal: {
                    FIR: "",
                    FIR_NAME: "",
                    COUNTRY: "",
                    AIRPORTS: ""
                },

            }
        },
        methods: {
            ...mapActions(["GetFIRs", "AddFir", "UpdateFir", "GetCountry", "DeleteFir",
                "GetNotamImportantList","AddNotamImportantWord","UpdateNotamImportantWord","DeleteNotamImportantWord"]),

            async TryAddRecord() {
                try {
                    this.AddFir(this.addModal);
                    this.addRecord = false;
                    //this.$notify({title: "Success", type: "success", text: "Succesfully"})
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryAddRecord FIR function e: " + e.message})
                }
            },

            async TryGetFIRs() {
                this.showLoading();
                try {
                    this.GetFIRs();
                } catch (e) {
                    //this.$notify({title: "Error", text: "Error on TryGetFIRs FIR function e: " + e.message, type: "error"})
                } finally {
                    this.hideLoading();
                }
            },
            firFilter(fir) {
                this.selectedFIR = fir;
                this.selectedFIRForm.FIR = fir.fir;
                this.selectedFIRForm.FIR_NAME = fir.fiR_NAME;
                this.selectedFIRForm.COUNTRY = fir.country;
                this.selectedFIRForm.AIRPORTS = fir.airports;
            },
            iseditRow(fir) {
                if (this.isEditing && this.selectedFIR == fir) {
                    return true;
                } else {
                    return false;
                }
            },
            async TryUpdateRecord() {
                try {

                    this.UpdateFir(this.selectedFIRForm);
                    //this.$notify({title: "Success", type: "success", text: "Succesfully"})
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryUpdateRecord FIR function e: " + e.message()})
                }
            },
            async TryDeleteRecord() {
                try {
                    /* Buraya bir swal koymak lazım. */

                    await this.$swal({
                        title: '<p style="text-align: left;font-size: 22px;">Do you want to delete FIR data?</p>',
                        html: "",
                        showCancelButton: true,
                        cancelButtonText: 'No',
                        cancelButtonColor: '#C5381A',
                        confirmButtonColor: '#1874DA',
                        confirmButtonText: 'Yes',
                    }).then(async (response) => {
                        if (response.value) {
                            //await this.deleteAirport(value);
                            this.DeleteFir(this.selectedFIRForm);

                            // this.$notify({
                            //     title: "Success",
                            //     text: "Succesfully",
                            //     type: "success"
                            // });
                        }
                    });

                    // this.UpdateFir(this.selectedFIRForm);
                    // this.$notify({title: "Success", type: "success", text: "Succesfully"})
                } catch (e) {
                    //this.$notify({title: "Error", type: "error", text: "Error on TryUpdateRecord FIR function e: " + e.message})
                }
            },

            NotamWordDeletionCancel()
            {
                this.deleteNotamWordsModal = false
                this.notamWordFormWillDelete = null
            },

            AssignDeletionItem(notam)
            {
                this.deleteNotamWordsModal = true
                this.notamWordFormWillDelete = notam
                console.log(this.notamWordFormWillDelete)
            },

            async NotamWordDeletionProcStart()
            {

                // delete eden fonksiyonu çağır gönder.


                console.log(this.notamWordFormWillDelete)
                await this.DeleteNotamWords(this.notamWordFormWillDelete);
                // işlem sonunda

                this.notamWordFormWillDelete =null;
            },

            GetTrueNotamButtonIsEditing(notam) {


                this.NotamImportantListModule=this.NotamImportantListModule.map((item)=>
                {
                   if(item.isEditing ==true)
                   {
                       item.isEditing = false;
                   }
                   else
                   {
                       return item;
                   }
                });

                this.notamWordsForm= {
                    Id: notam.id,
                    Word: notam.word,
                    Color: notam.color,
                    Style: notam.style,
                    IsDeleted: notam.isDeleted,
                    WhoChanged: "",
                    isEditing: true
                }

                this.editNotamButton = true;
                notam.isEditing = true;
            },

            GetFalseNotamButtonIsEditing(notam) {

                this.editNotamButton = false;
                notam.isEditing = false;
            },
            //--------------------------------------------------
            async AddNotamWords(notamWordsForm) {

                //  var IsDeleted = 0
                //  var WhoChanged = ""
                //  var word = notamWordsForm.Word
                //  var color = notamWordsForm.Color
                //  var style = notamWordsForm.Style

                var notamimportandWordModal ={
                    Word: notamWordsForm.Word,
                    Color: notamWordsForm.Color,
                    Style: notamWordsForm.Style
                }

                try {

                    // await WeatherMatrixService.FirInsertOrUpdate(0, word, color, style, IsDeleted, WhoChanged);
                    await this.AddNotamImportantWord(notamimportandWordModal);

                    //this.$notify({title: "Success", type: "success", text: "Notam Important Word added."})
                } catch (e) {
                    // this.$notify({
                    //     title: "Error",
                    //     type: "error",
                    //     text: "Error on AddNotamImportantWord function, " + e + " function e: " + e.message
                    // })
                } finally {
                    await this.clearNotamWordsForm();
                }
            },


            async UpdateNotamWords(notamWordsForm) {
                //var IsDeleted = 0
                //var WhoChanged = ""
                try
                {

                    console.log(notamWordsForm)
                       // await this.UpdateNotamImportantWord(notamWordsForm);
                        await this.UpdateNotamImportantWord(this.notamWordsForm);
                        //await WeatherMatrixService.FirInsertOrUpdate(notamWordsForm.id, notamWordsForm.Word, notamWordsForm.Color,notamWordsForm.Style, IsDeleted, WhoChanged);
                }
                catch (e) {
                    // this.$notify({
                    //     title: "Error",
                    //     type: "error",
                    //     text: "Error on UpdateNotamWords function, " + e + " function e: " + e.message
                    // })
                }
            },

            async DeleteNotamWords(notamWordsForm)
            {
                // var IsDeleted = 1
                // var WhoChanged = ""

                try
                {
                    await this.DeleteNotamImportantWord(notamWordsForm)
                    //await WeatherMatrixService.FirInsertOrUpdate(notamWordsForm.id, notamWordsForm.Word, notamWordsForm.Color,notamWordsForm.Style, IsDeleted, WhoChanged);
                    //this.$notify({title: "Success", type: "success", text:"Notam Important Word Deleted." })
                }
                catch (e) {
                    //this.$notify({title: "Error", type: "error", text:"Error on DeleteNotamWords, "+e+" function e: " + e.message})
                }


            },

            async GetNotamImportantWords()
            {
                try {
                     await this.GetNotamImportantList()


                }
                catch(e)
                {
                    //this.$notify({title: "Error", type: "error", text:"Error on GetNotamImportantWords, "+e+" function e: " + e.message})

                }


            }

        },

        clearNotamWordsForm()
        {
            this.notamWordsForm={
                Id: 0,
                Word: "",
                Color: "",
                Style: "",
                IsDeleted: 0,
                WhoChanged: "",
                isEditing: false
            }


        },

        deneme() {

        },

        //-----------------------------------------------------------------

        computed: {
            ...mapState(["FIRsList", "countryList","NotamImportantListModule"]),
            isDisabledCancel() {
                if (this.isEditing || this.addRecord) {
                    return true;
                } else {
                    return false;
                }
            },

            notamWordsColor() {
                return this.notamWordsForm.Color
            }
        },
        mounted() {
            this.GetFIRs();
        },
        created() {
            this.TryGetFIRs();
            this.GetCountry();
            this.GetNotamImportantWords();
        },

        watch: {
            notamWordsColor(newNotamWordsColor)
            {
                console.log(newNotamWordsColor)
            }
        }

    }
</script>

<style scoped>
    .fir-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .fir-table td {
        border: 0px;
    }

    .fir-table {
        overflow-y: scroll;
        height: 780px;
    }

    .fir-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }


    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border: 3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

    .modal-confirm {
        color: #636363;
        width: 400px;
    }
    .modal-confirm .modal-content {
        padding: 20px;
        border-radius: 5px;
        border: none;
        text-align: center;
        font-size: 14px;
    }
    .modal-confirm .modal-header {
        border-bottom: none;
        position: relative;
    }
    .modal-confirm h4 {
        text-align: center;
        font-size: 26px;
        margin: 30px 0 -10px;
    }
    .modal-confirm .close {
        position: absolute;
        top: -5px;
        right: -2px;
    }
    .modal-confirm .modal-body {
        color: #999;
    }
    .modal-confirm .modal-footer {
        border: none;
        text-align: center;
        border-radius: 5px;
        font-size: 13px;
        padding: 10px 15px 25px;
    }
    .modal-confirm .modal-footer a {
        color: #999;
    }
    .modal-confirm .icon-box {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        border-radius: 50%;
        z-index: 9;
        text-align: center;
        border: 3px solid #f15e5e;
    }
    .modal-confirm .icon-box i {
        color: #f15e5e;
        font-size: 46px;
        display: inline-block;
        margin-top: 13px;
    }
    .modal-confirm .btn, .modal-confirm .btn:active {
        color: #fff;
        border-radius: 4px;
        background: #60c7c1;
        text-decoration: none;
        transition: all 0.4s;
        line-height: normal;
        min-width: 120px;
        border: none;
        min-height: 40px;
        border-radius: 3px;
        margin: 0 5px;
    }
    .modal-confirm .btn-secondary {
        background: #c1c1c1;
    }
    .modal-confirm .btn-secondary:hover, .modal-confirm .btn-secondary:focus {
        background: #a8a8a8;
    }
    .modal-confirm .btn-danger {
        background: #f15e5e;
    }
    .modal-confirm .btn-danger:hover, .modal-confirm .btn-danger:focus {
        background: #ee3535;
    }
    .trigger-btn {
        display: inline-block;
        margin: 100px auto;
    }
    .modal-card-body {
        padding: 0;
    }


</style>
